import {
  FiUsers,
  FiHome,
  FiSettings,
  FiBellOff,
  FiAirplay,
  FiWatch,
} from "react-icons/fi";
import { FaRegNewspaper, FaQuoteRight } from "react-icons/fa";
import { MdFeedback } from "react-icons/md";
import { BsPersonWorkspace } from "react-icons/bs";
import { parseJWT } from "../utils/jwtUtils";

const token = localStorage.getItem("userInfo");
const userRole = parseJWT(token);

const isAdminOrSupperAdmin =
  userRole?.role === "user" || userRole?.role === "admin";
const isCurator = userRole?.role === "curators";

export const links = [
  // Conditionally add "Customers" link based on `isAdminOrSupperAdmin`
  ...(isAdminOrSupperAdmin
    ? [
        {
          name: "Home Page",
          icon: <FiHome />,
          url: "/dashboard",
        },
        {
          name: "Customers",
          icon: <FiUsers />,
          subLinks: [
            {
              name: "View Customer",
              url: "/customers",
            },
            {
              name: "Add Customer",
              url: "/signup",
            },
          ],
        },

        {
          name: "News",
          icon: <FiBellOff />,
          url: "/all-news",
        },

        {
          name: "Messages",
          icon: <MdFeedback />,
          url: "/messages",
        },
        {
          name: "Testimonials",
          icon: <FaQuoteRight />,
          url: "/all-testimonials",
        },

        {
          name: "About",
          icon: <FiAirplay />,
          subLinks: [
            {
              name: "About Info",
              url: "/all-teams",
            },
            {
              name: "Add Member",
              url: "/add-teams",
            },
            {
              name: "All Partners",
              url: "/all-partners",
            },
            {
              name: "New Partner",
              url: "/add-partners",
            },
          ],
        },
        {
          name: "Appointment",
          icon: <FiWatch />,
          url: "/show-appointments",
        },
      ]
    : []),
  {
    name: "Setting",
    icon: <FiSettings />,
    url: "/setting",
  },
];
